import AdminConfig from './AdminConfig';

export default AdminConfig;
